import { render, staticRenderFns } from "./OccasionFilterMobile.vue?vue&type=template&id=324da39b&scoped=true&"
import script from "./OccasionFilterMobile.vue?vue&type=script&lang=js&"
export * from "./OccasionFilterMobile.vue?vue&type=script&lang=js&"
import style0 from "./OccasionFilterMobile.vue?vue&type=style&index=0&id=324da39b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324da39b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Globaltask\\Documents\\Happybox Store\\Happybox Site\\src\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('324da39b')) {
      api.createRecord('324da39b', component.options)
    } else {
      api.reload('324da39b', component.options)
    }
    module.hot.accept("./OccasionFilterMobile.vue?vue&type=template&id=324da39b&scoped=true&", function () {
      api.rerender('324da39b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "BuildABox/components/MobileFilters/OccasionFilterMobile.vue"
export default component.exports